<article class="toolbar">
  <div class="container">
    <div class="u-flex u-alignCenter u-justifyBetween">
      @if (!!navigationService.config.showLogoInToolbar) {
        <a
          (click)="logoClicked.emit()"
          class="nav__logo"
          tabindex="0"
          [attr.aria-label]="navigationService.config.alt"
        >
        </a>
      }

      @if (navigationService.config.showImage) {
        <img
          class="nav__image"
          [src]="navigationService.config.imageLink"
          alt="Navigation"
        />
      }

      @if (!!navigationService.config.toolbar?.languageSelector?.languages) {
        <language-selector
          class="toolbar__lang"
          [config]="
            navigationService.config.toolbar?.languageSelector?.languages
          "
          mode="tab"
        ></language-selector>
      }

      @if (!!navigationService.config.toolbar.routes && isLoggedIn) {
        <div class="toolbar__dropdown">
          @if (navigationService.config.toolbar.routes.length > 1) {
            <div
              class="toolbar__dropdown__toggle"
              [ngClass]="{ 'is-open': !!dropdownOpen }"
              (click)="dropdownOpen = !dropdownOpen"
            >
              @if (navigationService.activeRoute) {
                <p class="t-data t-bold">
                  {{ navigationService.activeRoute.label }}
                </p>
              }
              <i class="icon icon--medium">carat_down</i>
            </div>
            @if (!!dropdownOpen) {
              <div class="toolbar__dropdown__menu">
                @if (navigationService.config.toolbar.label) {
                  <header class="toolbar__dropdown__menu__header">
                    <p class="t-caption t-alt">
                      {{ navigationService.config.toolbar.label }}
                    </p>
                  </header>
                }
                @for (
                  route of navigationService.config.toolbar.routes;
                  track route;
                  let i = $index
                ) {
                  <div
                    class="toolbar__dropdown__menu__item"
                    [ngClass]="{
                      'is-active': i === navigationService.activeRouteIdx,
                    }"
                    (click)="
                      navigationService.navigateSelected(route, i);
                      dropdownOpen = false
                    "
                  >
                    @if (route.icon) {
                      <i class="icon icon--medium">
                        {{
                          i === navigationService.activeRouteIdx
                            ? route.icon + '_active'
                            : route.icon
                        }}
                      </i>
                    }
                    <p class="t-data t-alt">{{ route.label }}</p>
                  </div>
                }
              </div>
            }
          }
        </div>
      }

      @if (icons && icons.length > 0) {
        <div
          class="toolbar__tools"
          [ngClass]="{
            'u-justifyEnd u-fillRemaining':
              !navigationService.config.toolbar.routes ||
              navigationService.config.showImage,
          }"
        >
          @for (tool of icons; track tool) {
            <a class="toolbar__tool" (click)="handleIconClick(tool)">
              @if (!!tool.icon) {
                <i class="icon icon--medium">{{ tool.icon }}</i>
              }
              @if (!tool.icon) {
                <span class="toolbar__tool-label t-data t-bold">{{
                  tool.label
                }}</span>
              }
              @switch (tool.count) {
                @case ('notifications') {
                  @if (notifications > 0) {
                    <span
                      class="toolbar__tool-count t-caption u-flex u-alignCenter u-justifyCenter"
                      >{{ notifications }}</span
                    >
                  }
                }
              }
            </a>
          }
        </div>
      }
    </div>
  </div>
</article>
